<template>
  <article
    :class="[
      {'-mx-8 sm:-mx-16 md:mx-0 md:-ml-100': content.image && index % 2 === 0},
      {'-mx-8 sm:-mx-16 md:mx-0 md:-mr-100': content.image && index % 2 !== 0},
      {'mt-24 sm:h-70v h-screen' : content.image}
    ]"
    class="my-12 bg relative bg-cover lazyload"
    :style="content.image ? `background-image: url('${content.image}');`: ''"
  >
    <div
      v-href
      :class="[index % 2 === 0 ? 'right-0 left-0 md:left-100' : 'right-0 left-0 md:right-100',{'absolute top-0 bottom-0 md:bottom-10pr':content.image}]"
      class="bg-primary-light text-white px-12 md:px-32 py-12"
    >
      <h3 v-if="content.time_slot" class="text-lg font-semibold xl:w-10/12">
        <font-awesome-icon :icon="['fas', 'history']" aria-hidden="true"/>
        {{ content.time_slot }}
      </h3>
      <div :class="{'sm:text-title':content.image}" class="title text-4xl leading-tight py-4 overflow-hidden truncate" v-html="title"/>
      <div class="description overflow-hidden" v-html="content.excerpt.replace(/\n/g, '<br />')"/>
      <div v-if="content.highlight && content.highlight.length" v-html="content.highlight"/>
      <nuxt-link
        :to="{name: `publicaties-slug`, params: {slug: content.slug}}"
        aria-label="Lees volledige artikel"
        class="block active-link text-lg text-white hover:text-secondary font-semibold pt-12"
      >
        Lees volledige artikel
        <font-awesome-icon :icon="['fas', 'arrow-circle-right']" class="ml-1" aria-hidden="true"/>
      </nuxt-link>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    publication: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    title() {
      return this.content.title.replace(/[*_]{2}([^*_]+)[*_]{2}/g, '<strong class="inline-block">$1</strong>');
    },
  },
};
</script>

<style  scoped>
.title {
  ::v-deep p {
    @apply leading-tight py-6 text-4xl;

    @media(min-width: theme('screens.md')) {
      @apply text-5xl;
    }
    @media(min-width: theme('screens.xxl')) {
      @apply w-10/12;
    }

    strong {
      @apply font-semibold;
    }
  }
}

.description,
.description > ::v-deep p {
  @apply leading-relaxed text-lg overflow-hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media(min-width: theme('screens.xxl')) {
    @apply w-10/12;
  }

  strong {
    @apply font-semibold;
  }
}

.description > ::v-deep p:not(:first-of-type) {
  display: none;
}
</style>
